<div class="modal-dialog">
<div class="modal-content">
  <div class="modal-header">Rename file</div>
  <div class="modal-body cl-form">

    <label for="dest_name" class="form-label">New file name</label>
    <input id="dest_name" type="text" [(ngModel)]="dest_name">

  </div>
  <div class="modal-footer">
    <app-form-footer label="Rename file" (action)="rename($event)">
      <button footerStart type="button" class="btn cl-color-secondary it-cancel" (click)="close()"><span>Cancel</span></button>
    </app-form-footer>
  </div>
  </div>
</div>
